import app from '@/app';
import templateUrl from './materials-services-detail.html';

/* @ngInject */
function Controller($controller, MaterialsServices, Principal) {
	var $ctrl = this;

	$ctrl.currentAccount = null;

	Principal.identity().then(account => {
		$ctrl.currentAccount = account;
	});

	$controller('AbstractEntityDetailController', {
		$ctrl,
		resource: MaterialsServices,
		type: 'materialsServices'
	});

}

const component = {
	templateUrl,
	controller: Controller,
	require: {
		parent: '^materialsServicesSearch'
	},
	bindings: {
		$transition$: '<',
		entity: '<'
	}
};

app.component('materialsServicesDetail', component);
